export const convertNameToUrlFormat = (text: string | undefined | null): string => {
	if (!text) {
		return '';
	}

	return text
		.toLowerCase()
		.replace(/[^'a-zA-Z\d]/g, '-')
		.replace(/(-)\1+/g, '$1')
		.replace(/-$/, '')
		.replace(/^-/, '');
};
